import { ExclamationMarkHexagonFillIcon } from '@grupoboticario/flora-react-icons';
import { Flex } from '@grupoboticario/flora-react';

import { getFormattedMessage } from '../helpers';
import { ResponsiveFloraTypography } from 'ui/components';

export const defaultErrorMessage = 'Tivemos um problema ao efetuar seu login. Tente novamente.';

export const MessageError = ({ message }: { message: string }) => {
  const { formattedMessage, componentView } = getFormattedMessage(message || defaultErrorMessage);

  return (
    <Flex gap="$2" align="center">
      <ExclamationMarkHexagonFillIcon size={16} color="$statusErrorActionableDefault" />
      <ResponsiveFloraTypography
        fontSize="exceptionsAuxiliar"
        fontWeight="regular"
        color="$statusInfoActionableAltContent"
      >
        {formattedMessage}
        {componentView}
      </ResponsiveFloraTypography>
    </Flex>
  );
};
